// src/pages/Accounting/Reconcile/components/LastReconciledLine.tsx

import type React from "react";
import { PALETTE } from "../constants";
import type { Reconciliation } from "../types";
import { formatCurrency, formatDateLong } from "../utils";

interface LastReconciledLineProps {
  reconciliation: Reconciliation;
  onViewHistory: () => void;
}

export function LastReconciledLine({
  reconciliation,
  onViewHistory,
}: LastReconciledLineProps) {
  return (
    <div style={containerStyle}>
      Last reconciled through{" "}
      <strong style={{ color: PALETTE.ink, fontWeight: 600 }}>
        {formatDateLong(reconciliation.periodEnd)}
      </strong>
      <span style={{ color: PALETTE.ink3, marginLeft: 6, fontWeight: 500 }}>
        ending balance {formatCurrency(reconciliation.statementEndingBalance)}
        {" \u00b7 "}
        <button type="button" onClick={onViewHistory} style={linkStyle}>
          View history &rarr;
        </button>
      </span>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  padding: "10px 0 14px",
  borderBottom: `1px solid ${PALETTE.line}`,
  marginBottom: 22,
  fontSize: 12.5,
  color: PALETTE.ink2,
  fontWeight: 500,
};

const linkStyle: React.CSSProperties = {
  color: PALETTE.velaDeep,
  fontWeight: 600,
  cursor: "pointer",
  background: "transparent",
  border: 0,
  padding: 0,
  font: "inherit",
};